// extracted by mini-css-extract-plugin
export var close = "FullScreenModal-module--close--30774";
export var container = "FullScreenModal-module--container--436aa";
export var content = "FullScreenModal-module--content--1e1c0";
export var header = "FullScreenModal-module--header--28219";
export var headerCentered = "FullScreenModal-module--headerCentered--ef106";
export var headerContent = "FullScreenModal-module--headerContent--b3c18";
export var headerLeft = "FullScreenModal-module--headerLeft--a459e";
export var modal = "FullScreenModal-module--modal--85b28";
export var positionBackButton = "FullScreenModal-module--positionBackButton--7e967";
export var withSubtitle = "FullScreenModal-module--withSubtitle--8bd12";